<template>
  <div class="stepper">
    <div class="step-desktop">
      <img :src="imageSrcD" alt="steps" />
    </div>
    <div class="step-mobile">
      <img :src="imageSrcM" alt="step" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Stepper',
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    imageSrcD() {
      return {
        'nominale': '../../../images/project-img/Step_Nominale_Desk.png',
        'sponsor': '../../../images/project-img/Step_Nominale_Desk.png',
        'live-market': '../../../images/project-img/Step_Livemarket_Desk.png',
        'storica': '../../../images/project-img/Step_Storica_Desk@.png',
        'ruote-classiche': '../../../images/project-img/Step_Classiche_Desk.png',
      }[this.type];
    },
    imageSrcM() {
      return {
        'nominale': '../../../images/project-img/Step_Nominale_Mobile.png',
        'sponsor': '../../../images/project-img/Step_Nominale_Mobile.png',
        'live-market': '../../../images/project-img/Step_Livemarket_Mobile.png',
        'storica': '../../../images/project-img/Step_Storica_Mobile.png',
        'ruote-classiche': '../../../images/project-img/Step_Classiche_Mobile.png',
      }[this.type];
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/Stepper.vue